import { useState } from "react";
import { PixChargeResponse } from "../../Models/Payment";
import { formatDateTimeToBR } from "../../Utils/DataFormatters";
import Button from "../Button/Button";

type PixPaymentStepProps = {
  pixData: PixChargeResponse;
};

const PixPaymentStep = ({ pixData }: PixPaymentStepProps) => {
  const [copied, setCopied] = useState(false);
  const expirationDate = pixData.expiration 
    ? formatDateTimeToBR(pixData.expiration)
    : null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pixData.pixCopyPaste);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      // swallow copy errors silently
    }
  };

  return (
    <div className="flex flex-col items-center text-center gap-5 p-4 sm:p-6 w-full max-w-3xl mx-auto">
      <h2 className="text-lg sm:text-xl font-bold">{"Pagamento PIX gerado!"}</h2>
      <p className="text-sm sm:text-base">{"Use o código ou QR Code abaixo para finalizar o pagamento."}</p>

      <div className="w-full bg-gray-100 rounded p-3 text-left max-h-24 overflow-y-auto break-all text-xs sm:text-sm">
        <code className="text-xs">{pixData.pixCopyPaste}</code>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 items-center justify-center w-full">
        <Button
          type="button"
          onClick={handleCopy}
          className="px-4 py-2 text-sm w-full sm:w-auto"
        >
          {"Copiar código PIX"}
        </Button>
        {copied && (
          <p className="text-xs text-green-600">{"Código copiado!"}</p>
        )}
      </div>

      <img src={pixData.qrCodeImage} alt={"QR Code PIX"} className="max-w-[200px] w-full" />
      {expirationDate && (
        <p className="text-xs sm:text-sm text-gray-600">
          {"Válido até"}: {expirationDate}
        </p>
      )}
      <p className="text-xs sm:text-sm text-gray-600 text-center">
        {"Realize o pagamento até o vencimento para evitar o cancelamento automático do pedido."}
      </p>
    </div>
  );
};

export default PixPaymentStep;
